export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      animation: false,
    },
  },
  legend: {
    data: ["时间1", "时间2"] as string[],
    right: 20,
    top: "5%",
    textStyle: {
      color: "#fff",
    },
  },
  axisPointer: {
    link: [
      {
        yAxisIndex: "all",
      },
    ],
  },
  grid: [
    {
      left: "50%",
      right: 70,
      top: "15%",
      bottom: "10%",
    },
    {
      left: 70,
      right: "50%",
      top: "15%",
      bottom: "10%",
    },
  ],
  xAxis: [
    {
      type: "value",
      name: "",
      // type: "category",
      max: undefined as any,
      interval: undefined as any,
      splitLine: {
        lineStyle: {
          color: "#b8b8b875",
          type: "dashed",
        },
      },
      axisLabel: {
        rotate: 30,
      },
    },
    {
      gridIndex: 1,
      type: "value",
      name: "",
      // type: "category",
      max: undefined as any,
      interval: undefined as any,
      inverse: true,
      splitLine: {
        lineStyle: {
          color: "#b8b8b875",
          type: "dashed",
        },
      },
      axisLabel: {
        rotate: 30,
      },
    },
  ],
  yAxis: [
    {
      // type: "value",
      type: "category",
      data: [] as string[],
      axisLabel: {
        show: false,
      },
    },
    {
      gridIndex: 1,
      // type: "value",
      data: [] as string[],
      type: "category",
    },
  ],
  series: [
    {
      name: "",
      data: [] as any[],
    } as any,
    {
      name: "",
      xAxisIndex: 1,
      yAxisIndex: 1,
      data: [] as any[],
    } as any,
  ],
  graphic: [{}] as any[],
}
